import useClickOutside from "../../hooks/useClickOutside"
import "./Alert.css"
import { AlertProps } from "./Alert.types"

/**
 * Alert is responsible for displaying an alert to the screen. Alert containes
 * a title, description and child components.
 * 
 * @prop {string} title       - title of the alert
 * @prop {string} description - text under title
 * @prop {componnet} children - react components to be displayed on alert
 * @prop {bool} showAlert     - controls if alert is displayed
 * @prop {bool} alignLeft     - controls if alert components are aligned left otherwise
 *                              they align centre
 * 
 */
const Alert = (props: AlertProps) => {

  const { children, showAlert, animated, onClose } = props
  const [{
    contextRef
  }] = useClickOutside({ onClickOutside: onClose })

  return (
    <div 
      className={`${showAlert ? "alert alert-show" : "alert alert-hide"} ${animated !== false ? "alert-animated" : ""}`}
      data-testid="alert"
    >
      <div className="child-components" ref={contextRef}>
        {children}
      </div>
    </div>
  )
}

export default Alert